/**
 * Render a calendar DAY that carries no time and no zone.
 *
 * PHA-1124: a postgres `date` (the device First Data Date, the RPM cycle
 * anchor) arrives over JSON as `2025-11-13T00:00:00.000Z`. Passing that through
 * `new Date(v).toLocaleDateString()` renders UTC midnight in the *viewer's*
 * zone, so an Eastern browser displays 11/12/2025 for a device whose stored
 * anchor -- and SmartMeter's own First Reading -- are both 2025-11-13. The
 * stored value was never wrong; only its display was.
 *
 * One day here is one 30-day cycle boundary out to whoever reads it, so this
 * formats from the yyyy-MM-dd prefix and never round-trips through `Date`.
 * Read-side twin of the write-side rule (bind the STRING, not a Date).
 *
 * Use it for date-only values. A real instant (a reading time, a link time)
 * SHOULD be localised, and belongs in `toLocaleString()` instead.
 */
export function formatDateOnly(value: string | null | undefined, fallback = '—'): string {
  if (!value) return fallback;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  // Anything unparseable is shown verbatim rather than silently blanked: a
  // billing anchor that renders as "—" reads as "not set", which is a
  // different and more dangerous claim than "we could not format this".
  if (!match) return String(value);
  const [, year, month, day] = match;
  return `${month}/${day}/${year}`;
}
